export default __webpack_public_path__ + "static/media/decada-0070-0009-min.91f7dafe.jpg";